import { Component, Input, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'ui-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: ['./input-textarea.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputTextareaComponent extends InputBaseComponent<string> {
  @Input() cols: number = 30;
  @Input() lengthHint: number = 0;
  @Input() name: string = uniqueId('textarea');
  @Input() placeholder: string = '';
  @Input() resize: boolean = false;
  @Input() rows: number = 10;
  @Input() tabindex?: number;

  get hint(): string {
    return this.lengthHint > 0 ? this.value.length + `/${this.lengthHint}` : '';
  }

  onBlur() {
    if (this.control.value !== this.value) {
      this._emit();
    }
  }

  onInputKeyDown($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this._emit();
    }
  }

  private _emit() {
    this.onTouched(this.value);
    this.onChange(this.value);
  }
}
